import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
//import { LOCAL_STORAGE } from '../storage/localstorage.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { LOCAL_STORAGE } from './localstorage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  accessPoint: any;
  resource: any;
  isLoggedIn: boolean | undefined;
  constructor(private router: Router, private http: HttpClient, private authService: AuthService, @Inject(LOCAL_STORAGE) private localStorage: Storage, private jwtHelper: JwtHelperService) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.localStorage.getItem('token') !== null) {
      return of(true);
      // if (next.url.length === 0) { // This needs to be checked why
      //   return of(true);
      // }
      //  else if (next.data.accessPoint !== undefined) {
      //   return this.authService.authorizeRequest(next.data).pipe(map(result => {
      //     if (result) {
      //       return true;
      //     } else {
      //       this.router.navigate(['/un-authorized']);
      //       return false;
      //     }
      //   }));
      // }
    } else {
      this.router.navigate(['/login']
      );
      return of(false);
    }
    return of(false);
  }

  // async canActivate() {
  //   const token = localStorage.getItem("token");

  //   if (token && !this.jwtHelper.isTokenExpired(token)) {
  //     console.log(this.jwtHelper.decodeToken(token));
  //     return true;
  //   }

  //   const isRefreshSuccess = await this.tryRefreshingTokens(token!);
  //   if (!isRefreshSuccess) {
  //     this.router.navigate(["login"]);
  //   }

  //   return isRefreshSuccess;
  // }

  // private async tryRefreshingTokens(token: string): Promise<boolean> {
  //   // Try refreshing tokens using refresh token
  //   const refreshToken: string | null = localStorage.getItem("refreshToken");

  //   if (!token || !refreshToken) {      
  //     return false;
  //   }

  //   const credentials = JSON.stringify({ accessToken: token, refreshToken: refreshToken });

  //   let isRefreshSuccess: boolean;
  //   try {
  //     const response = await this.http.post("http://localhost:5000/api/token/refresh", credentials, {
  //       headers: new HttpHeaders({
  //         "Content-Type": "application/json"
  //       }),
  //       observe: 'response'
  //     }).toPromise();
  //     // If token refresh is successful, set new tokens in local storage.
  //     const newToken = (<any>response).body.accessToken;
  //     const newRefreshToken = (<any>response).body.refreshToken;
  //     localStorage.setItem("jwt", newToken);
  //     localStorage.setItem("refreshToken", newRefreshToken);
  //     isRefreshSuccess = true;
  //   }
  //   catch (ex) {      
  //     isRefreshSuccess = false;
  //   }
  //   return isRefreshSuccess;
  // }

}